module.exports = __webpack_public_path__ + "static/img/guide3.78a2ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guide3.png
// module id = CIzQ
// module chunks = 10